import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vShow as _vShow, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white font-gotham-medium" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16" }
const _hoisted_4 = { class: "mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_5 = { class: "mt-1" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "sm:col-span-2 mt-4" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "mt-1" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = ["min"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "mt-6 flex space-x-2" }
const _hoisted_23 = { class: "flex items-center h-5" }
const _hoisted_24 = {
  key: 0,
  class: "mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4"
}
const _hoisted_25 = { class: "mt-1" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "mt-10 border-t border-gray-200 pt-10" }
const _hoisted_30 = {
  key: 0,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4"
}
const _hoisted_31 = { class: "col-span-4" }
const _hoisted_32 = { class: "mt-1" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "col-span-4" }
const _hoisted_35 = { class: "mt-1" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "col-span-3" }
const _hoisted_38 = { class: "mt-1" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "mt-1" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "mt-6 grid grid-cols-4 gap-y-6 gap-x-4"
}
const _hoisted_43 = { class: "col-span-3" }
const _hoisted_44 = { class: "mt-1" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "mt-1" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "mt-10 lg:mt-0" }
const _hoisted_49 = { class: "" }
const _hoisted_50 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_51 = { class: "py-6 px-4 space-y-6 sm:px-6" }
const _hoisted_52 = { class: "flex justify-between items-center" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = { class: "min-w-0 flex-1" }
const _hoisted_55 = { class: "mt-1 text-lg" }
const _hoisted_56 = { class: "text-base font-medium text-gray-900" }
const _hoisted_57 = { class: "flex items-center justify-between border-t border-gray-200 pt-6" }
const _hoisted_58 = { class: "text-sm font-light pr-6" }
const _hoisted_59 = ["href"]
const _hoisted_60 = { class: "text-base font-medium text-gray-900" }
const _hoisted_61 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_62 = {
  key: 0,
  class: "text-red-400"
}
const _hoisted_63 = ["href"]
const _hoisted_64 = { class: "text-base font-medium text-gray-900" }
const _hoisted_65 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 pt-6"
}
const _hoisted_66 = { class: "text-sm font-light h-64 overflow-hidden" }
const _hoisted_67 = { class: "flex items-center justify-between border-t border-gray-200 pt-6" }
const _hoisted_68 = { class: "text-sm font-light pr-6" }
const _hoisted_69 = ["href"]
const _hoisted_70 = { class: "text-base font-medium text-gray-900" }
const _hoisted_71 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_72 = { class: "min-w-0 flex-1 p-4" }
const _hoisted_73 = {
  key: 0,
  class: "mt-1 font-normal text-sm text-green-500"
}
const _hoisted_74 = {
  key: 1,
  class: "mt-1 font-normal text-sm text-red-500"
}
const _hoisted_75 = { class: "mt-4 bg-white border border-gray-200 rounded-lg shadow-sm" }
const _hoisted_76 = {
  role: "list",
  class: "divide-y divide-gray-200"
}
const _hoisted_77 = { class: "" }
const _hoisted_78 = { class: "min-w-0 flex-1" }
const _hoisted_79 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_80 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_81 = {
  key: 0,
  class: "mt-1 text-sm text-gray-500"
}
const _hoisted_82 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_83 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_84 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_85 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_86 = { class: "border-t border-gray-200 pb-6" }
const _hoisted_87 = { class: "ml-6 flex-1 flex flex-col" }
const _hoisted_88 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_89 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_90 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_91 = { class: "text-sm pb-4" }
const _hoisted_92 = { class: "tooltip" }
const _hoisted_93 = { class: "ml-6 flex-1 flex flex-col pb-4" }
const _hoisted_94 = { class: "flex-1 flex flex-row-reverse items-start justify-between" }
const _hoisted_95 = { class: "flex-1 flex flex-row-reverse items-start" }
const _hoisted_96 = {
  key: 0,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_97 = {
  key: 0,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_98 = {
  key: 1,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_99 = {
  key: 2,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_100 = {
  key: 3,
  class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6"
}
const _hoisted_101 = { class: "flex items-center justify-between border-t border-gray-200 py-6 px-4 sm:px-6" }
const _hoisted_102 = { class: "text-base font-medium text-gray-900" }
const _hoisted_103 = { class: "flex items-center justify-between px-4 sm:px-6" }
const _hoisted_104 = { class: "text-sm font-extralight" }
const _hoisted_105 = { class: "font-medium" }
const _hoisted_106 = { class: "border-t border-gray-200 py-6 px-4 sm:px-6" }
const _hoisted_107 = {
  key: 0,
  class: "mt-4 text-sm text-red-600"
}
const _hoisted_108 = {
  key: 1,
  class: "mt-4 text-sm text-red-600"
}

import { computed, reactive, ref, watch } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { helpers, email, required, requiredIf, minLength, maxLength, integer } from '@vuelidate/validators';
import { ccValidations } from '@/validations/ccValidations';
import { nameValidations } from '@/validations/nameValidations';
import { OrderServiceInterface } from '@/services/orderServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { Product } from '@/adapters/catalogAdapterInterface';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import AsyncButton from '../library/AsyncButton.vue';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';
import format from 'date-fns/format';
import addDays from 'date-fns/fp/addDays';
import store from '@/store';
import { InformationCircleIcon } from '@heroicons/vue/outline';
import { RecaptchaV2, useRecaptcha } from 'vue3-recaptcha-v2';

// Adding this prevents Vue warnings
import { Switch } from '@headlessui/vue';
import { Action, Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';
import CsgTerms from '@/components/content/CsgTerms.vue';

export type ContactInformation = {
  firstName: string | null,
  lastName: string | null,
  phoneNumber: string | null,
  email: string
};

type Service = {
  id: string,
  address: string,
  carrier: string,
  locationId: string,
  requiresNewDevelopmentCost: boolean,
  development: string,
  suburb: string,
  state: string,
  rtcDays: number,
}

type ConfirmOrderData = {
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: number | null,
  companyName: string,
  abnNumber: number | null,
  ccNumber: number | null,
  ccName: string,
  ccExpiry: string,
  ccCvc: string,
  ddAccountNumber: string,
  ddAccountBsb: string,
  token?: string,
  activationDate: string,
  formSelectionOptions: {
    businessAccount: boolean,
    paymentMethod: string,
    confirmAddressToggle: boolean,
    termsAgreementToggle: boolean,
    csgWaiverToggle: boolean,
    toggleExpandCsgWaiver: boolean,
    ddAgreementToggle: boolean,
    pickActivationDate: boolean
  },
  captchaValid: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderFormOld',
  props: {
    errors: {},
    products: {},
    service: {},
    isPromoValid: { type: Boolean },
    promotionDiscounts: {},
    validPromotion: {},
    suggestedPromotion: {}
  },
  emits: ["onEnterPromoCode", "onConfirmOrder", "onContactInformation"],
  setup(__props: any, { emit: __emit }) {

const orderService = injectStrict<OrderServiceInterface>('OrderServiceInterface');
const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

const delayedNdc = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'DELAYED-NDC');
});

const yearOff = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'YEAR-OFF');
});

const monthOff = computed(() => {
  let plan = '';
  if (props.products.length > 0 && props.products.filter(pr => pr.type === 'internet').length > 0) {
    plan = props.products.filter(pr => pr.type === 'internet')[0].id;
  }
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'ONE-OFF' && (discount.applicableTo.length <= 0 || (discount.applicableTo.length > 0 && discount.applicableTo.includes(plan))));
});

const preInstalledRouter = computed(() => {
  return props.promotionDiscounts.find(discount => discount.actionCatalogObject.code === 'FREE-ROUTER-INSTALLED');
});

const account = computed(() => {
  return store.state.account;
});

const salesPerson = computed(() => {
  return store.state.salesPerson;
});

const isPromoValid = computed(() => {
  return props.isPromoValid;
});

const voiceProduct = computed(() => {
  return props.products.filter(product => product.type === 'voice').length > 0;
});

const today = computed((): string => {
  return format(new Date(), 'yyyy-MM-dd');
});

const tomorrow = computed((): string => {
  return format(addDays(1, new Date()), 'yyyy-MM-dd');
});

const formData : ConfirmOrderData = reactive({
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: null,
  companyName: '',
  abnNumber: null,
  ccNumber: null,
  ccName: '',
  ccExpiry: '',
  ccCvc: '',
  ddAccountNumber: '',
  ddAccountBsb: '',
  token: '',
  crmId: null,
  activationDate: today.value,
  formSelectionOptions: {
    businessAccount: false,
    paymentMethod: 'cc',
    confirmAddressToggle: false,
    termsAgreementToggle: false,
    csgWaiverToggle: false,
    toggleExpandCsgWaiver: false,
    ddAgreementToggle: false,
    pickActivationDate: false
  },
  captchaValid: false
});

const { handleReset } = useRecaptcha();

const handleWidgetId = (widgetId: number) => {
  handleReset(widgetId);
};
const handleErrorCalback = () => {
  formData.captchaValid = false;
};
const handleExpiredCallback = () => {
  formData.captchaValid = false;
};
const handleLoadCallback = (response: unknown) => {
  if (response) {
    formData.captchaValid = true;
  }
};

const promoCode = ref(props.suggestedPromotion?.code);

function promoCodeClickHandler () {
  let promoCodeUppercase;
  if (promoCode.value) {
    promoCodeUppercase = promoCode.value.toUpperCase();
  }
  emit('onEnterPromoCode', promoCodeUppercase);
}

const contactInformation : ContactInformation = reactive({
  firstName: null,
  lastName: null,
  phoneNumber: null,
  email: ''
});

const pickActivationDate = ref(() => formData.formSelectionOptions.pickActivationDate);
const businessAccount = ref(() => formData.formSelectionOptions.businessAccount);
const paymentMethodRequiredCc = ref(() => formData.formSelectionOptions.paymentMethod === 'cc' && (!salesPerson.value));
const paymentMethodRequiredDd = ref(() => formData.formSelectionOptions.paymentMethod === 'dd' && (!salesPerson.value));

const rules = {
  firstName: {
    required: helpers.withMessage('Please enter a firstname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  lastName: {
    required: helpers.withMessage('Please enter a lastname', required),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(20))
  },
  email: {
    required: helpers.withMessage('Please enter an email address', required),
    email: helpers.withMessage('Please enter a valid email address', email)
  },
  phoneNumber: {
    required: helpers.withMessage('This field cannot be empty', required),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(10)),
    maxLengthValue: helpers.withMessage('Please enter a phone number with 10 digits', maxLength(10))
  },
  companyName: {
    requiredIf: helpers.withMessage('Please enter a company name', requiredIf(businessAccount.value)),
    minLength: helpers.withMessage('Please enter a phone number with 10 digits', minLength(1)),
    maxLengthValue: helpers.withMessage('Please enter less than 50 chars', maxLength(50)),
    nameValidation: helpers.withMessage('Please enter letters only', nameValidations.nameValidation)
  },
  abnNumber: {
    requiredIf: helpers.withMessage('Please enter an ABN number', requiredIf(businessAccount.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 11 digit ABN number', minLength(11)),
    maxLength: helpers.withMessage('Please enter a 11 digit ABN number', maxLength(11))
  },
  ccNumber: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    ccValidation: helpers.withMessage('Please enter a valid credit card number', ccValidations.numberValidation)
  },
  ccName: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    maxLengthValue: helpers.withMessage('Please enter less than 20 chars', maxLength(40))
  },
  ccExpiry: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccExpiryValidation: helpers.withMessage('Please enter a valid MM/YY expiry', ccValidations.expiryValidation)
  },
  ccCvc: {
    requiredIf: helpers.withMessage('Please enter a credit card number', requiredIf(paymentMethodRequiredCc.value)),
    ccCvcValidation: helpers.withMessage('Please enter a valid CVC number', ccValidations.cvcValidation)
  },
  ddAccountNumber: {
    requiredIf: helpers.withMessage('Please enter an account number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a valid account number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a valid account number', maxLength(10))
  },
  ddAccountBsb: {
    requiredIf: helpers.withMessage('Please enter a BSB number', requiredIf(paymentMethodRequiredDd.value)),
    integer: helpers.withMessage('Please enter numbers only', integer),
    minLength: helpers.withMessage('Please enter a 6 digit BSB number', minLength(6)),
    maxLength: helpers.withMessage('Please enter a 6 digit BSB number', maxLength(6))
  },
  activationDate: {
    requiredIf: helpers.withMessage('Please select a date the service should be activated', requiredIf(pickActivationDate.value))
  }
};
const v$ = useVuelidate(rules, formData);

const directDebitFormFields = computed(() => {
  return formData.formSelectionOptions.paymentMethod !== 'cc';
});

// eslint-disable-next-line func-call-spacing
const emit = __emit;

const confirmAddressError = ref(false);
const termsAgreementError = ref(false);
const ddAgreementError = ref(false);
const csgWaiverError = ref(false);
const captchaError = ref(false);

const handleConfirmOrder = async (done: () => void) => {
  const formValidated = await v$.value.$validate();

  if (!formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = true;
  if (!formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = true;
  if (!formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = true;
  if (voiceProduct.value && !formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = true;

  if (!voiceProduct.value) {
    if (formValidated && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !captchaError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  } else if (voiceProduct.value) {
    if (formValidated && voiceProduct.value && !confirmAddressError.value && !termsAgreementError.value && !ddAgreementError.value && !csgWaiverError.value && !captchaError.value) {
      emit('onConfirmOrder', formData, done);
    } else {
      done();
    }
  }
};

const handleClickConfirmAddress = () => {
  if (formData.formSelectionOptions.confirmAddressToggle) confirmAddressError.value = false;
};

const handleClickTermsAgreement = () => {
  if (formData.formSelectionOptions.termsAgreementToggle) termsAgreementError.value = false;
};

const handleClickCsgWaiver = () => {
  if (formData.formSelectionOptions.csgWaiverToggle) csgWaiverError.value = false;
};

const handleClickDdAgreement = () => {
  if (formData.formSelectionOptions.ddAgreementToggle) ddAgreementError.value = false;
};

const handleClickBusinessAccount = () => {
  formData.companyName = '';
  formData.abnNumber = null;
};

const handleActivationDate = () => {
  if (formData.formSelectionOptions.pickActivationDate) {
    formData.activationDate = tomorrow.value;
  } else {
    formData.activationDate = today.value;
  }
};

const handleFirstNameBlur = () => {
  v$.value.firstName.$touch();

  if (!v$.value.firstName.$error) {
    contactInformation.firstName = formData.firstName;
  } else {
    contactInformation.firstName = null;
  }
};

const handleLastNameBlur = () => {
  v$.value.lastName.$touch();

  if (!v$.value.lastName.$error) {
    contactInformation.lastName = formData.lastName;
  } else {
    contactInformation.lastName = null;
  }
};

const handlePhoneBlur = () => {
  v$.value.phoneNumber.$touch();

  if (!v$.value.phoneNumber.$error) {
    contactInformation.phoneNumber = formData.phoneNumber;
  } else {
    contactInformation.phoneNumber = null;
  }
};

const handleEmailBlur = () => {
  v$.value.email.$touch();

  if (!v$.value.email.$error) {
    contactInformation.email = formData.email;
  } else {
    contactInformation.email = null;
  }
};

const toggleExpandCsgWaiver = () => {
  formData.formSelectionOptions.toggleExpandCsgWaiver = !formData.formSelectionOptions.toggleExpandCsgWaiver;
};

watch(
  contactInformation,
  (newContactInformation) => {
    if (newContactInformation.email) {
      emit('onContactInformation', newContactInformation);
    }
  }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[83] || (_cache[83] = _createElementVNode("h2", { class: "sr-only" }, "Checkout", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _cache[41] || (_cache[41] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Contact information", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _cache[31] || (_cache[31] = _createElementVNode("label", {
                  for: "first-name",
                  class: "block text-sm font-medium text-gray-700"
                }, "First name", -1)),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "first-name",
                    name: "first-name",
                    autocomplete: "given-name",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.firstName) = $event)),
                    onBlur: handleFirstNameBlur,
                    class: "block border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm w-4/5"
                  }, null, 544), [
                    [_vModelText, formData.firstName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "firstName-error"
                  }, [
                    (error.$property === 'firstName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _cache[32] || (_cache[32] = _createElementVNode("label", {
                  for: "last-name",
                  class: "block text-sm font-medium text-gray-700"
                }, "Last name", -1)),
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "last-name",
                    name: "last-name",
                    autocomplete: "family-name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.lastName) = $event)),
                    onBlur: handleLastNameBlur,
                    class: "block w-4/5 border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                  }, null, 544), [
                    [_vModelText, formData.lastName]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "lastName-error"
                  }, [
                    (error.$property === 'lastName')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[33] || (_cache[33] = _createElementVNode("label", {
                for: "email-address",
                class: "block text-sm font-medium text-gray-700"
              }, "Email address", -1)),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  id: "email-address",
                  name: "email-address",
                  autocomplete: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.email) = $event)),
                  onBlur: handleEmailBlur,
                  class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                }, null, 544), [
                  [_vModelText, formData.email]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "email-error"
                }, [
                  (error.$property === 'email')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[34] || (_cache[34] = _createElementVNode("label", {
                for: "phone",
                class: "block text-sm font-medium text-gray-700"
              }, "Phone", -1)),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "phone",
                  id: "phone",
                  autocomplete: "tel",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.phoneNumber) = $event)),
                  onBlur: handlePhoneBlur,
                  class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                }, null, 544), [
                  [_vModelText, formData.phoneNumber]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: error.$uid,
                  class: "mt-2 text-sm text-red-600",
                  id: "phoneNumber-error"
                }, [
                  (error.$property === 'phoneNumber')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(error.$message), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[36] || (_cache[36] = _createElementVNode("label", {
                  for: "activationDateOption",
                  class: "block text-sm font-medium text-gray-700"
                }, "Service activation date", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    id: "activationDateOption",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.formSelectionOptions.pickActivationDate) = $event)),
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm",
                    onChange: handleActivationDate
                  }, _cache[35] || (_cache[35] = [
                    _createElementVNode("option", { value: false }, "ASAP", -1),
                    _createElementVNode("option", { value: true }, "Pick a Date", -1)
                  ]), 544), [
                    [_vModelSelect, formData.formSelectionOptions.pickActivationDate]
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _cache[37] || (_cache[37] = _createElementVNode("label", {
                  for: "activationDate",
                  class: "block text-sm font-medium text-gray-700"
                }, "Confirm service activation date", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    min: tomorrow.value,
                    name: "activationDate",
                    id: "activationDate",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.activationDate) = $event)),
                    onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_unref(v$).activationDate.$touch && _unref(v$).activationDate.$touch(...args))),
                    class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                  }, null, 40, _hoisted_20), [
                    [_vModelText, formData.activationDate]
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "mt-2 text-sm text-red-600",
                    id: "activationDate-error"
                  }, [
                    (error.$property === 'activationDate')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(error.$message), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 512), [
                [_vShow, formData.formSelectionOptions.pickActivationDate]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  onClick: handleClickBusinessAccount,
                  id: "same-as-shipping",
                  name: "same-as-shipping",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.formSelectionOptions.businessAccount) = $event)),
                  class: "h-4 w-4 border-gray-400 border-solid rounded text-brand-accent focus:ring-brand-accent"
                }, null, 512), [
                  [_vModelCheckbox, formData.formSelectionOptions.businessAccount]
                ])
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("label", {
                for: "same-as-shipping",
                class: "text-sm font-medium text-gray-900"
              }, "Is this a business account?", -1))
            ]),
            (formData.formSelectionOptions.businessAccount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", null, [
                    _cache[39] || (_cache[39] = _createElementVNode("label", {
                      for: "company-name",
                      class: "block text-sm font-medium text-gray-700"
                    }, "Company name", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "company-name",
                        name: "company-name",
                        autocomplete: "organization",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.companyName) = $event)),
                        onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(v$).companyName.$touch && _unref(v$).companyName.$touch(...args))),
                        class: "block w-4/5 border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.companyName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "companyName-error"
                      }, [
                        (error.$property === 'companyName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[40] || (_cache[40] = _createElementVNode("label", {
                      for: "abn-number",
                      class: "block text-sm font-medium text-gray-700"
                    }, "ABN Number", -1)),
                    _createElementVNode("div", _hoisted_27, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "abn-number",
                        name: "abn-number",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.abnNumber) = $event)),
                        onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(v$).abnNumber.$touch && _unref(v$).abnNumber.$touch(...args))),
                        class: "block w-4/5 border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.abnNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "abnNumber-error"
                      }, [
                        (error.$property === 'abnNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[48] || (_cache[48] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Payment Method", -1)),
            (!directDebitFormFields.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                      for: "card-number",
                      class: "block text-sm font-medium text-gray-700"
                    }, "Card number", -1)),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "card-number",
                        name: "card-number",
                        autocomplete: "cc-number",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.ccNumber) = $event)),
                        onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(v$).ccNumber.$touch && _unref(v$).ccNumber.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ccNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccNumber-error"
                      }, [
                        (error.$property === 'ccNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _cache[43] || (_cache[43] = _createElementVNode("label", {
                      for: "name-on-card",
                      class: "block text-sm font-medium text-gray-700"
                    }, "Name on card", -1)),
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "name-on-card",
                        name: "name-on-card",
                        autocomplete: "cc-name",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.ccName) = $event)),
                        onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_unref(v$).ccName.$touch && _unref(v$).ccName.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ccName]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccName-error"
                      }, [
                        (error.$property === 'ccName')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", {
                      for: "expiration-date",
                      class: "block text-sm font-medium text-gray-700"
                    }, "Expiration date (MM/YY)", -1)),
                    _createElementVNode("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "expiration-date",
                        id: "expiration-date",
                        autocomplete: "cc-exp",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.ccExpiry) = $event)),
                        onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_unref(v$).ccExpiry.$touch && _unref(v$).ccExpiry.$touch(...args))),
                        class: "block w-4/5 border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ccExpiry]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccExpiry-error"
                      }, [
                        (error.$property === 'ccExpiry')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[45] || (_cache[45] = _createElementVNode("label", {
                      for: "cvc",
                      class: "block text-sm font-medium text-gray-700"
                    }, "CVC", -1)),
                    _createElementVNode("div", _hoisted_40, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "cvc",
                        id: "cvc",
                        autocomplete: "cc-csc",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.ccCvc) = $event)),
                        onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_unref(v$).ccCvc.$touch && _unref(v$).ccCvc.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ccCvc]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ccCvc-error"
                      }, [
                        (error.$property === 'ccCvc')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (directDebitFormFields.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[46] || (_cache[46] = _createElementVNode("label", {
                      for: "account-number",
                      class: "block text-sm font-medium text-gray-700"
                    }, "Account Number", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "account-number",
                        id: "account-number",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.ddAccountNumber) = $event)),
                        onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountNumber.$touch && _unref(v$).ddAccountNumber.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ddAccountNumber]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountNumber-error"
                      }, [
                        (error.$property === 'ddAccountNumber')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", {
                      for: "bsb",
                      class: "block text-sm font-medium text-gray-700"
                    }, "BSB", -1)),
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "bsb",
                        id: "bsb",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.ddAccountBsb) = $event)),
                        onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                        class: "block w-full border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
                      }, null, 544), [
                        [_vModelText, formData.ddAccountBsb]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).$errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: error.$uid,
                        class: "mt-2 text-sm text-red-600",
                        id: "ddAccountBsb-error"
                      }, [
                        (error.$property === 'ddAccountBsb')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(error.$message), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _cache[80] || (_cache[80] = _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Confirm Details", -1)),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _cache[49] || (_cache[49] = _createElementVNode("p", { class: "text-xs text-brand-secondary font-light" }, " Confirm your service address below. ", -1)),
                      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.service.address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickConfirmAddress,
                      modelValue: formData.formSelectionOptions.confirmAddressToggle,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.formSelectionOptions.confirmAddressToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.confirmAddressToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (confirmAddressError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[52] || (_cache[52] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'translate-x-3' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[50] || (_cache[50] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-gray-400",
                              fill: "none",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", {
                                d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]), 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.confirmAddressToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[51] || (_cache[51] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-brand-accent",
                              fill: "currentColor",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                            ], -1)
                          ]), 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [52]
                    }, 8, ["modelValue", "class"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _cache[53] || (_cache[53] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/terms-and-conditions.pdf`,
                      target: "_blank",
                      class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250"
                    }, "Terms and Conditions.", 8, _hoisted_59)
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickTermsAgreement,
                      modelValue: formData.formSelectionOptions.termsAgreementToggle,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formData.formSelectionOptions.termsAgreementToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.termsAgreementToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (termsAgreementError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[56] || (_cache[56] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'translate-x-3' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[54] || (_cache[54] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-gray-400",
                              fill: "none",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", {
                                d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]), 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.termsAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[55] || (_cache[55] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-brand-accent",
                              fill: "currentColor",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                            ], -1)
                          ]), 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [56]
                    }, 8, ["modelValue", "class"])
                  ])
                ]),
                (voiceProduct.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("div", {
                        class: "text-sm font-light",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (toggleExpandCsgWaiver()))
                      }, [
                        _cache[58] || (_cache[58] = _createTextVNode(" I have read, understood and accept the ")),
                        _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250" }, "CSG waiver.", -1)),
                        (formData.formSelectionOptions.csgWaiverToggle && salesPerson.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_62, [
                              _cache[57] || (_cache[57] = _createTextVNode("Ensure you have read the ")),
                              _createElementVNode("a", {
                                class: "text-red-600",
                                href: _ctx.$router.resolve({ name: 'csg-waiver-script' }).href,
                                target: "_blank"
                              }, "CSG Waiver Script", 8, _hoisted_63)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_unref(Switch), {
                          onClick: handleClickCsgWaiver,
                          modelValue: formData.formSelectionOptions.csgWaiverToggle,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formData.formSelectionOptions.csgWaiverToggle) = $event)),
                          class: _normalizeClass([
                        (formData.formSelectionOptions.csgWaiverToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (csgWaiverError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                        }, {
                          default: _withCtx(() => [
                            _cache[62] || (_cache[62] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'translate-x-3' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                                "aria-hidden": "true"
                              }, _cache[60] || (_cache[60] = [
                                _createElementVNode("svg", {
                                  class: "h-3 w-3 text-gray-400",
                                  fill: "none",
                                  viewBox: "0 0 12 12"
                                }, [
                                  _createElementVNode("path", {
                                    d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                  })
                                ], -1)
                              ]), 2),
                              _createElementVNode("span", {
                                class: _normalizeClass([formData.formSelectionOptions.csgWaiverToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                                "aria-hidden": "true"
                              }, _cache[61] || (_cache[61] = [
                                _createElementVNode("svg", {
                                  class: "h-3 w-3 text-brand-accent",
                                  fill: "currentColor",
                                  viewBox: "0 0 12 12"
                                }, [
                                  _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                                ], -1)
                              ]), 2)
                            ], 2)
                          ]),
                          _: 1,
                          __: [62]
                        }, 8, ["modelValue", "class"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (voiceProduct.value && formData.formSelectionOptions.toggleExpandCsgWaiver)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(CsgTerms, {
                          firstName: contactInformation.firstName,
                          lastName: contactInformation.lastName,
                          brand: _unref(brandService).getTitle(),
                          phone: _unref(brandService).getSupportPhoneNumber(),
                          address: _unref(brandService).getAddress()
                        }, null, 8, ["firstName", "lastName", "brand", "phone", "address"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _cache[63] || (_cache[63] = _createTextVNode(" I have read, understood and accept the ")),
                    _createElementVNode("a", {
                      href: `https://uniti-bpo-website-assets.assets.unitiinternet.com/${_unref(brandService).getName()}/direct-debit-service-request-agreement.pdf`,
                      target: "_blank",
                      class: "text-blue-500 hover:text-blue-800 hover:underline transition duration-250"
                    }, "Direct Debit Service Request Agreement.", 8, _hoisted_69)
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createVNode(_unref(Switch), {
                      onClick: handleClickDdAgreement,
                      modelValue: formData.formSelectionOptions.ddAgreementToggle,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formData.formSelectionOptions.ddAgreementToggle) = $event)),
                      class: _normalizeClass([
                        (formData.formSelectionOptions.ddAgreementToggle ? 'bg-brand-accent' : 'bg-gray-200'),
                        ('relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200'),
                        (ddAgreementError.value ? 'ring-2 ring-offset-2 ring-red-600' : 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent')
                        ])
                    }, {
                      default: _withCtx(() => [
                        _cache[66] || (_cache[66] = _createElementVNode("span", { class: "sr-only" }, "Use setting", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'translate-x-3' : 'translate-x-0', 'pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-0 ease-out duration-100' : 'opacity-100 ease-in duration-200', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[64] || (_cache[64] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-gray-400",
                              fill: "none",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", {
                                d: "M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]), 2),
                          _createElementVNode("span", {
                            class: _normalizeClass([formData.formSelectionOptions.ddAgreementToggle ? 'opacity-100 ease-in duration-200' : 'opacity-0 ease-out duration-100', 'absolute inset-0 h-full w-full flex items-center justify-center transition-opacity']),
                            "aria-hidden": "true"
                          }, _cache[65] || (_cache[65] = [
                            _createElementVNode("svg", {
                              class: "h-3 w-3 text-brand-accent",
                              fill: "currentColor",
                              viewBox: "0 0 12 12"
                            }, [
                              _createElementVNode("path", { d: "M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" })
                            ], -1)
                          ]), 2)
                        ], 2)
                      ]),
                      _: 1,
                      __: [66]
                    }, 8, ["modelValue", "class"])
                  ])
                ])
              ])
            ])
          ]),
          _cache[81] || (_cache[81] = _createElementVNode("h2", { class: "mt-9 text-lg font-medium text-gray-900" }, "Promotions", -1)),
          _createElementVNode("div", _hoisted_71, [
            _cache[68] || (_cache[68] = _createElementVNode("h3", { class: "sr-only" }, "Enter promotion code here", -1)),
            _createElementVNode("div", _hoisted_72, [
              _cache[67] || (_cache[67] = _createElementVNode("label", {
                for: "promoCode",
                class: "block text-sm font-medium text-gray-700 pb-1"
              }, "Enter promotion code", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "promoCode",
                id: "promoCode",
                autocomplete: "off",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((promoCode).value = $event)),
                onBlur: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(v$).ddAccountBsb.$touch && _unref(v$).ddAccountBsb.$touch(...args))),
                class: "uppercase border-gray-200 rounded-md shadow-sm focus:ring-brand-accent focus:border-brand-accent sm:text-sm"
              }, null, 544), [
                [_vModelText, promoCode.value]
              ]),
              _createElementVNode("button", {
                onClick: promoCodeClickHandler,
                type: "button",
                class: "inline-flex items-center ml-2 px-3.5 py-2.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-accent"
              }, "Apply"),
              (isPromoValid.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_73, "Promo code " + _toDisplayString(_ctx.validPromotion?.code) + " applied!", 1))
                : _createCommentVNode("", true),
              (!isPromoValid.value && promoCode.value && promoCode.value.length > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_74, "Promo code invalid!"))
                : _createCommentVNode("", true)
            ])
          ]),
          _cache[82] || (_cache[82] = _createElementVNode("h2", { class: "mt-9 text-lg font-medium text-gray-900" }, "Order summary", -1)),
          _createElementVNode("div", _hoisted_75, [
            _cache[79] || (_cache[79] = _createElementVNode("h3", { class: "sr-only" }, "Items in your cart", -1)),
            _createElementVNode("ul", _hoisted_76, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("li", {
                  key: product.name,
                  class: "flex py-6 px-4 sm:px-6"
                }, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("h4", _hoisted_79, _toDisplayString(product.name), 1),
                      _createElementVNode("p", _hoisted_80, _toDisplayString(product.description), 1),
                      (product.type !== 'hardware')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_81, " Monthly "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("p", {
                        class: _normalizeClass(['text-sm font-medium', isPromoValid.value && product.discounted ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.type === 'internet' || product.type === 'voice' || product.type === 'hardware']
                ])
              }), 128))
            ]),
            _createElementVNode("dl", _hoisted_86, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between px-4 sm:px-6"
                }, [
                  _cache[69] || (_cache[69] = _createElementVNode("dt", { class: "text-sm py-6" }, " Activation Fee ", -1)),
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      (product.price >= 0 && !isPromoValid.value || !product.displayDiscount)
                        ? (_openBlock(), _createElementBlock("dd", {
                            key: 0,
                            class: _normalizeClass(['text-sm font-medium', isPromoValid.value && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                          }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_90, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.code === 'ACTIVATION-FEE']
                ])
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: product.name,
                  class: "flex items-center justify-between border-t border-gray-200 pt-6 px-4 sm:px-6"
                }, [
                  _createElementVNode("dt", _hoisted_91, [
                    _cache[71] || (_cache[71] = _createTextVNode(" New Development Fee ")),
                    _createElementVNode("div", _hoisted_92, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(InformationCircleIcon)), {
                        class: "h-6 w-6 text-brand-button-text",
                        "aria-hidden": "true"
                      })),
                      _cache[70] || (_cache[70] = _createElementVNode("span", { class: "tooltiptext" }, [
                        _createElementVNode("p", { class: "tooltipmsg" }, "The New Development Charge or NDC is a charge that is passed on from the network wholesale provider to residents via the Retail Service Provider. This fee is applied to all new developments as a one-time fee for the first user to activate an internet service.")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("dd", {
                        class: _normalizeClass(['text-sm font-medium', isPromoValid.value && product.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900'])
                      }, _toDisplayString(_unref(utilityService).formatCurrency(product.price)), 3)
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      (isPromoValid.value && product.discounted)
                        ? (_openBlock(), _createElementBlock("dd", _hoisted_96, _toDisplayString(_unref(utilityService).formatCurrency(product.discountedPrice ?? 0)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])), [
                  [_vShow, product.code === 'NDC']
                ])
              }), 128)),
              (delayedNdc.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, _cache[72] || (_cache[72] = [
                    _createElementVNode("dt", { class: "text-sm font-extralight" }, " The new development fee of $300 will be applied in month 13 ", -1)
                  ])))
                : _createCommentVNode("", true),
              (yearOff.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, _cache[73] || (_cache[73] = [
                    _createElementVNode("dt", { class: "text-sm font-extralight" }, " First Year Free! - Standard billing will commence in month 13 ", -1)
                  ])))
                : _createCommentVNode("", true),
              (monthOff.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_99, _cache[74] || (_cache[74] = [
                    _createElementVNode("dt", { class: "text-sm font-extralight" }, " First Month Free! ", -1)
                  ])))
                : _createCommentVNode("", true),
              (preInstalledRouter.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, _cache[75] || (_cache[75] = [
                    _createElementVNode("dt", { class: "text-sm font-extralight" }, " Pre-Installed router ", -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_101, [
                _cache[76] || (_cache[76] = _createElementVNode("dt", { class: "text-base font-medium" }, " First Invoice Total ", -1)),
                _createElementVNode("dd", _hoisted_102, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateFirstInvoiceTotal(_ctx.products, isPromoValid.value, _ctx.validPromotion))), 1)
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("dt", _hoisted_104, [
                  _cache[77] || (_cache[77] = _createTextVNode(" The total minimum cost of service over duration of the contract selected less any discounts is ")),
                  _createElementVNode("span", _hoisted_105, _toDisplayString(_unref(utilityService).formatCurrency(_unref(orderService).calculateMinimumCost(_ctx.products, isPromoValid.value, _ctx.validPromotion))), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_106, [
              _createVNode(AsyncButton, {
                onOnClick: handleConfirmOrder,
                class: "w-full"
              }, {
                default: _withCtx(() => _cache[78] || (_cache[78] = [
                  _createTextVNode("Confirm Order")
                ])),
                _: 1,
                __: [78]
              }),
              _createElementVNode("div", null, [
                (confirmAddressError.value || termsAgreementError.value || ddAgreementError.value || csgWaiverError.value )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_107, " Please confirm your details and tick the required fields "))
                  : _createCommentVNode("", true),
                (_unref(v$).$error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_108, " Please fill out all required form fields "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: error,
                    class: "mt-4 text-sm text-red-600"
                  }, _toDisplayString(error), 1))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})